
    export enum EnumLocLabelType {
			All = 0,
			None = 1,
			InHouse = 2,
			PrivateLabel = 3,
			InHouseAndPrivateLabel = 4,
			Transport = 5,
			InternalWash = 6,
			UpgradeWash = 7,
			MaintenanceWash = 8,
			AnyWash = 9,
			StorageFacility = 10,
			StorageTanks = 11,
			AnyStorage = 12,
			AnyWashAndStorage = 13,
			Repack = 14,
    }